import $ from 'jquery';

const normId = (myid) => '#' + myid.replace(/(:|\.|\[|\])/g, '\\$1');

export const goAjaxForm = ({
                               form_id = '#form',
                               button_id = '#form-submit',
                               out_id = '#form-out',
                               onSuccess = () => {
                               },
                               onError = () => {
                               },
                               reset = true,
                               scroll = true,
                               show_msg_ok = true,
                           }) => {

    const $form = $(form_id);
    const $button = $(button_id);
    let $out = $(out_id);

    $form.ajaxForm({
        dataType: 'json',
        beforeSubmit: () => {
            if ($button.length) {
                $button.prop('disabled', true);
            }
        },
        success: function (data) {
            if (data.cap_key) {
                $('.captcha', $form).attr('src', data.cap_image);
                $('#id_captcha_0', $form).val(data.cap_key);
                $('#id_captcha_1', $form).val('');
            }

            $('.errorlist').remove();

            if (data.result === 'success') {

                if (!$out.length && show_msg_ok) {
                    $form.before(`<div id="${out_id.replace('#', '')}" class="alert alert-success"></div>`);
                    $out = $(out_id);
                    $out.text(data.message);
                }

                if (reset) {
                    $form.resetForm();
                }

                if (!show_msg_ok) {
                    $out.remove();
                }

                onSuccess(data);

                if (scroll && $out.length) $('html,body').animate({'scrollTop': $out.offset().top - 80}, 'fast');
            } else {

                if (data.errors) {
                    $out.remove();
                    $.each(data.errors, (key, value) => {
                        const el = `<ul class="errorlist"><li>${value}</li></ul>`;
                        let $bl = $(normId(`id_${key}`), $form);
                        if (!$bl.length) $bl = $(normId(`id_${key}_1`), $form);
                        $bl.closest($bl).after(el);
                        $bl.focus();
                        if (data.errors.__all__) {
                            $form.before(`<div id="${out_id.replace('#', '')}" class="alert alert-danger"></div>`);
                            $out = $(out_id);
                            $out.text(data.errors.__all__[0]);
                        }
                    });

                    onError(data);
                }
            }
            $('.x', $out).click(() => $(this).parent().slideUp());

            if ($button.length) {
                $button.prop('disabled', false);
            }
        },
    });
};


export const captchaRefresh = $form => {
    const url = location.protocol + '//' + window.location.hostname + ':'
        + location.port + '/captcha/refresh/';

    $.getJSON(url, {}, function (json) {
        $form.find('input[name="captcha_0"]').val(json.key);
        $form.find('img.captcha').attr('src', json.image_url);
    });
};



// WEBPACK FOOTER //
// ./js/common/ajax-form.js